<template>
  <v-container fill-height style="height: 100vh">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12" v-if="!recovery_form">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Login Form</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                prepend-icon="mdi-account"
                name="login"
                label="Login"
                type="login"
                v-model="login"
                :rules="loginRules"
                @keypress.enter="submit"
                required
                data-cy="signinEmailField"
              />
              <v-text-field
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
                data-cy="signinPasswordField"
                v-model="password"
                :rules="passwordRules"
                @keypress.enter="submit"
                required
              />
              <v-text-field
                prepend-icon="mdi-lock"
                name="twofa"
                label="Code"
                type="twofa"
                data-cy="signinTwofaField"
                v-model="twofa"
                :rules="twofaRules"
                @keypress.enter="submit"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              color="primary"
              small
              @click="recovery = !recovery"
              data-cy="signinSubmitBtn"
            >Forgot password?
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!valid"
              :loading="loading"
              @click="submit"
              data-cy="signinSubmitBtn"
            >Login
            </v-btn>

          </v-card-actions>
          <v-expand-transition>
            <v-row class="mx-auto mt-0 pr-2 pl-4" v-show="recovery">
              <v-divider class="col-12 mt-4 mb-0 pt-0 pb-1" />

              <v-text-field
                prepend-icon="mdi-mail"
                label="Email"
                v-model="email"
              />

              <v-btn
                small
                color="primary"
                class="mt-4 ml-4"
                :loading="loading"
                @click="sendRecovery"
              >Send
              </v-btn>
            </v-row>
          </v-expand-transition>

        </v-card>
        <v-card class="elevation-12" v-else>
          <v-toolbar dark color="primary">
            <v-toolbar-title>New Password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="re_form" v-model="re_valid">
              <v-text-field
                prepend-icon="mdi-lock"
                name="re_password"
                label="Password"
                type="text"
                data-cy="signinPasswordField"
                v-model="new_password"
                :rules="newPasswordRules"
                required
              />
              <v-text-field
                prepend-icon="mdi-lock"
                name="re_new_password"
                label="Re-Password"
                type="text"
                data-cy="signinPasswordField"
                v-model="re_new_password"
                :rules="[...newPasswordRules, passwordMatch]"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!re_valid"
              @click="new_password_submit"
              data-cy="signinSubmitBtn"
            >Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { API } from '@/utils/api'
  import { get } from 'lodash'

  export default {
    name: 'Signin',
    data: () => ({
      loading: false,
      recovery: false,
      recovery_form: false,
      new_password: '',
      re_new_password: '',
      email: '',
      valid: false,
      re_valid: false,
      login: '',
      password: '',
      twofa: '',
      loginRules: [
        v => !!v || 'Login is required',
        v => v.length >= 3 || 'Login must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        // v => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(v) || 'Password must be greater than 6 characters'
      ],
      newPasswordRules: [
        v => !!v || 'Password is required',
        v => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(v) || 'Password must be greater than 8 characters, A-Za-z0-9 (at least one lower and one upper case char and number)',
      ],
      twofaRules: [
        v => /^[0-9]*$/.test(v) || 'Code must be valid'
      ]
    }),

    computed: {
      passwordMatch () {
        return () => (this.new_password === this.re_new_password || 'Passwords doesn\'t match')
      }
    },

    mounted () {
      if (this.$route.query.token) {
        this.loading = true
        return API.call('/recovery.json', { token: this.$route.query.token }).then(resp => {

          if (resp.data.valid_token) {
            this.recovery_form = true
            this.new_password = (Math.random().toString(36) + '00000000000000000').slice(2, 8).toUpperCase() + (Math.random().toString(36) + '00000000000000000').slice(2, 8)
            this.re_new_password = this.new_password
          }

          return resp
        }).catch(err => {
        }).finally(() => {
          this.loading = false
          // this.$router.push('/login')
        })
      }
    },
    methods: {
      submit () {
        if (this.$refs.form.validate() && !this.loading) {
          const { login, password, twofa } = this
          this.loading = true
          this.$store.dispatch('auth/login', { login, password, twofa }).then((r) => {
            if (get(r, 'user.settings.type') == 'cashier') {
              this.$router.push('/kiosk/dashboard')
            } else {
              const redirect = this.$route.query.redirect
              if (redirect) {
                return this.$router.push(redirect)
              }
              this.$router.push('/')
            }
          }).catch(err => {
          }).finally(() => {
            this.loading = false
          })

        }
      },
      new_password_submit () {
        if (this.$refs.re_form.validate()) {
          this.loading = true
          return API.call('/recovery.json', { token: this.$route.query.token, password: this.new_password, re_password: this.re_new_password }).then(resp => {

            this.$router.push('/login')
            this.recovery_form = false

            if (resp.message) {
              this.$notification.show = true
              this.$notification.message = resp.message
              this.$notification.type = 'success'
            }

            return resp
          }).catch(err => {
          }).finally(() => {
            this.loading = false
            // this.$router.push('/login')
          })

        }
      },

      sendRecovery () {
        if (this.loading) return

        if (!this.email || this.email.length == 0) {
          this.$notification.show = true
          this.$notification.message = 'Email can\'t be empty'
          this.$notification.type = 'error'
          return
        }

        this.loading = true
        return API.call('/recovery.json', { email: this.email }).then(resp => {
          this.$notification.show = true
          this.$notification.message = 'Recovery Email was sen\'t!'
          this.$notification.type = 'success'
          return resp
        }).catch(err => {
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
